import { Vue } from "vue-property-decorator";

const loadingController = new Vue({
    data: {
        loading: false
    },
    methods: {
        show_loading() {
            this.loading = true;
        },
        hide_loading() {
            this.loading = false;
        }
    }
})

export default loadingController;